import React, { useContext, useState } from 'react'
import { MeetingPageContext } from './MeetingPage'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  IconButton,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material'
import TipTap from '../../../components/TipTap/TipTap'
import { DetailRow } from '../../../components/Cards/DetailsBox'
import EditIcon from '@mui/icons-material/Edit'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import BigModal from '../../../components/Modals/BigModal'
import AddAgendaPopup from './NewMeeting/AddAgendaPopup'

const AgendaAccordion = ({ agendaKey }) => {
  const {
    setAgendas,
    expandedAgendaAccordions,
    setExpandedAgendaAccordions,
    agendas,
    setChangesPresent,
    meeting,
  } = useContext(MeetingPageContext)

  const agendaItem = agendas?.[agendaKey]

  const [openEditAgendaItem, setOpenEditAgendaItem] = useState(false)

  return (
    <Accordion
      disableGutters
      expanded={expandedAgendaAccordions.includes(agendaItem?.title)}
      onChange={(e, value) =>
        setExpandedAgendaAccordions((prev) =>
          expandedAgendaAccordions.includes(agendaItem?.title)
            ? prev.filter((x) => x !== agendaItem?.title)
            : [...prev, agendaItem?.title]
        )
      }
      sx={{
        border: 'solid 1px',
        borderColor: agendaItem?.markComplete ? 'anGreen.main' : 'anRed.main',
        borderRadius: 1,
      }}
    >
      <AccordionSummary>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Typography variant="title2" fontSize="1rem" fontWeight="bold">
            {agendaItem?.title}
          </Typography>
          <IconButton
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setOpenEditAgendaItem(true)
            }}
            size="small"
          >
            <EditIcon color="anMainBlue" fontSize="small" />
          </IconButton>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 1 }}>
        <Stack gap={1} paddingLeft={1}>
          <Typography>{agendaItem?.description ?? ''}</Typography>
          {agendaItem?.cqcQualityStatement?.length > 0 && (
            <DetailRow
              label="CQC"
              value={agendaItem.cqcQualityStatement.join(', ')}
            />
          )}
          <DetailRow
            label="Lead"
            value={agendaItem?.lead?.map((x) => x.firstName + ' ' + x.lastName)}
          />
          <DetailRow label="Time" value={agendaItem?.estimatedTime + ' mins'} />
          <FormControlLabel
            label="Mark Complete"
            control={
              <Switch
                checked={agendaItem?.markComplete ?? false}
                color="success"
                onChange={(e) => {
                  setAgendas((prev) =>
                    prev.map((item, i) =>
                      i === agendaKey
                        ? { ...item, markComplete: e.target.checked }
                        : item
                    )
                  )
                  setChangesPresent(true)
                }}
              />
            }
          />
        </Stack>
      </AccordionDetails>
      <BigModal
        open={!!openEditAgendaItem}
        onClose={() => setOpenEditAgendaItem(false)}
      >
        <AddAgendaPopup
          staffOptions={meeting?.invitees ?? []}
          setAgendaItems={setAgendas}
          agendaItems={agendas}
          onClose={(title) => {
            setOpenEditAgendaItem(false)
            setExpandedAgendaAccordions((prev) => [...prev, title])
          }}
          existingAgenda={agendas[agendaKey]}
          existingAgendaPosition={agendaKey}
          setChangesPresent={setChangesPresent}
        />
      </BigModal>
    </Accordion>
  )
}

export default AgendaAccordion
